"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutBucketMetricsConfigurationOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=PutBucketMetricsConfigurationOutput.js.map